import axios from "axios";

export default {
    data() {
        return {
        // web_url: "https://devseedmobileapi.azurewebsites.net/api/v1/", //dev link
        // web_urlV2: "https://devseedmobileapi.azurewebsites.net/api/v2/", //dev v2
        // web_urlV3: "https://devseedmobileapi.azurewebsites.net/api/v3/", //dev v2
        // web_urlV4: "https://devseedmobileapi.azurewebsites.net/api/v4/", //dev v4
        // web_urlV5: "https://devseedmobileapi.azurewebsites.net/api/v5/", //dev v5
        // env : "Test_"

       web_url: "https://seedmobileapi.azurewebsites.net/api/v1/", //dev link
        web_urlV2: "https://seedmobileapi.azurewebsites.net/api/v2/", //dev v2
        web_urlV3: "https://seedmobileapi.azurewebsites.net/api/v3/", //dev v2
        web_urlV4: "https://seedmobileapi.azurewebsites.net/api/v4/", //dev v4
        web_urlV5: "https://seedmobileapi.azurewebsites.net/api/v5/", //dev v5
        web_urlV6: "https://seedmobileapi.azurewebsites.net/api/v6/", //dev v6
        web_urlV7: "https://seedmobileapi.azurewebsites.net/api/v7/", //dev v6
        env : "Prod_",
        screentime:18000000
        }
  },
  methods: {
    async getFavourite() {
      let self = this;
      await this.$axios
        .get(`${self.web_urlV6}Contents/GetFavoriteMobile?UserID=`+parseInt(localStorage.getItem("UserID")))
        .then(function (res) {
          let favcount = res.data.data.length;
          self.$store.commit("savefavCount", favcount);
        });

    },
    async getNotificationCount() {
      let self = this;
      const request = {
        userId: parseInt(localStorage.getItem("UserID")),
        companyId: localStorage.getItem("companyID"),
      };
      await axios
        .post(
          `${self.web_urlV3}Notification/GetAllNotificationMobileV4`,
          request
        )
        .then(function (result) {
          if (result.data.status == 0) {
            let d1 = result.data.data.filter(
              (x) => x.viewOrNot === false
            ).length;
            let d2 = result.data.data1.filter((x) => x.newNoti === false).length;
            let d3 = result.data.data2.filter((x) => x.newNoti === false).length;
            let d4 = result.data.data4.filter((x) => x.newNoti === false).length;
            let d5 = result.data.data5.filter((x) => x.newNoti === false).length;
            let d6 = result.data.data6.filter((x) => x.newNoti === false).length;
            let d7 = result.data.data7.filter((x) => x.newNoti === false).length;
            let d8 = result.data.data8.filter((x) => x.newNoti === false).length;
            let d9 = result.data.data3.filter((x) => x.newNoti === false).length;
            let notiCount = d1 + d2 + d3 + d4 + d5 + d6 + d7 + d8 + d9;
            self.$store.commit("savenotiCount", notiCount);
          }
        });
    },
    //R12 check permissions for crud..
    check_Permissions(title) {
      let temp_item = JSON.parse(
        localStorage.getItem("menu_items_crud") || "[]"
      );
      
      return temp_item.find((v) => v.title == title).crud_access;
    },
    async check_menu_permission() {
      let companyID = localStorage.getItem("companyID");
      let userID = parseInt(localStorage.getItem("UserID"));

      if (companyID == null) {
        return false;
      }
      let request = {
        companyID: companyID,
        userID: userID,
      };
      const res = await this.$axios.post(
        `${this.web_url}EmployeeEXT/CheckPermissionWeb`,
        request
      );

      this.menu_items = this.itemsData(res.data.data);
      this.menuItems_crud = this.itemsCrudData(res.data.data);

      let outer_permission = [];

      for (const element of this.menu_items) {
        let items__ = [];
        //filter sub_items
        if (element.items) {
          items__ = element.items.filter(
            (v) => v.permission === true
          );
          element.items = items__;
        }
        if (
          element.title == "setting" ||
          element.title == "home" ||
          element.title == "report"
        ) {
          if (element.items.length == 0) {
            outer_permission.push({ title: element.title });
          }
        }
        if (element.permission === false) {
          outer_permission.push({ title: element.title });
        }
      }
      //filter items
      if (outer_permission.length != 0) {
        for (const element of outer_permission) {
          this.menu_items = this.menu_items.filter(
            (t) => t.title != element.title
          );
        }
      }
      localStorage.setItem(
        "menu_items_crud",
        JSON.stringify(this.menuItems_crud)
      );
      localStorage.setItem("menu_items", JSON.stringify(this.menu_items));
    },

    itemsCrudData(data) {
      return [
        //home
        {
          title: "library",
          crud_access: data.libraryView,
        },
        {
          title: "lessonlearn",
          crud_access: data.lessonLearnView,
        },
        {
          title: "course",
          crud_access: data.courseView,
          view_type: data.courseAllorGroup,
        },
        {
          title: "quiz",
          crud_access: data.quizView,
          view_type: data.quizAllorGroup,
        },
        {
          title: "community",
          crud_access: data.communityView,
        },
        {
          title: "event",
          crud_access: data.eventView,
        },
        {
          title: "feedbackbox",
          crud_access: data.feedbackView,
        },
        {
          title: "companypoliciesandregulations",
          crud_access: data.companypoliciesandregulationsView,
        },
        {
          title: "banner",
          crud_access: data.bannerView,
        },
        //..
        {
          title: "usermanagement",
          crud_access: data.userManagementView,
        },
        {
          title: "companyprofile",
          crud_access: data.companyProfileView,
        },
        {
          title: "sendnotification",
          crud_access: data.sendNotificationView,
        },
        //setting noti
        {
          title: "notification",
          crud_access: data.settingNotificationView,
        },
      ];
    },

    itemsData(checkdata) {
      return [
        {
          action: "mdi-home-variant-outline",
          active: false,
          items: [
            {
              title: "library",
              href: "/home/library",
              // permission: checkdata.libraryFlag,
            },
            {
              title: "lessonlearn",
              href: "/home/lesson-learn",
              // permission: checkdata.lessonLearnFlag,
            },
            {
              title: "course",
              href: "/home/assignment-course",
              // permission: checkdata.courseFlag,
            },
            {
              title: "quiz",
              href: "/home/quiz",
              // permission: checkdata.quizFlag,
            },
            {
              title: "community",
              href: "/home/community",
              // permission: checkdata.communityFlag,
            },
            {
              title: "event",
              href: "/home/event",
              // permission: checkdata.eventFlag,
            },
            {
              title: "feedbackbox",
              href: "/home/feedback-box",
              // permission: checkdata.feedbackFlag,
            },
            {
              title: "companypolicies&regulations",
              href: "/home/companypolicies&regulations",
              // permission: checkdata.feedbackFlag,
            },
            {
              title: "banner",
              href: "/home/banner",
              // permission: checkdata.bannerFlag,
            },
          ],
          title: "home",
        },
        {
          action: "mdi-file-document",
          active: false,
          items: [
            {
              title: "useractivity",
              href: "/report/user-activity",
              permission: checkdata.userActivityFlag,
            },
            {
              title: "usagemetrics",
              href: "/report/usage-metrics",
              permission: checkdata.usageMetricsFlag,
            },
            {
              title: "userview",
              href: "/report/user-view",
              permission: checkdata.userViewFlag,
            },
            {
              title: "requesteduserreport",
              href: "/report/requested-user",
              permission: checkdata.requestedUserFlag,
            },
            {
              title: "ACReport",
              href: "/report/assignment-course",
              permission: checkdata.assignmentReportFlag,
            },
          ],
          title: "report",
        },
        {
          action: "mdi-account",
          active: false,
          title: "usermanagement",
          href: "/user-management",
          permission: checkdata.userManagementFlag,
        },
        {
          action: "mdi-badge-account-horizontal",
          active: false,
          title: "companyprofile",
          href: "/company-profile",
          permission: checkdata.companyProfileFlag,
        },
        {
          action: "mdi-bell-ring",
          active: false,
          title: "sendnotification",
          href: "/notification-page",
          permission: checkdata.sendNotificationFlag,
        },
        {
          action: "mdi-cog-outline",
          active: false,
          items: [
            {
              title: "notification",
              href: "/setting/notificationpage",
              permission: checkdata.settingNotificationFlag,
            },
          ],
          title: "setting",
        },
      ];
    },

    addData(url, body, parse = false) {
      const headers = this.getAuthorizationHeader();

      if (parse) {
        return new Promise((resolve, reject) => {
          axios
            .post(`${this.web_url}${url}`, body, headers)
            .then((res) => resolve(res.data.data))
            .catch((err) => reject(err));
        });
      } else {
        return axios.post(`${this.web_url}${url}`, body, headers);
      }
    },
    // authenticateData(body, authentication) {
    //   if (authentication.active) {
    //     if (authentication.hasOwnProperty("rules")) {
    //       for (const [key, callback] of Object.entries(authentication.rules)) {
    //         if (callback instanceof Function) {
    //           if (key == "*") {
    //             for (const [bodykey, value] of Object.entries(body)) {
    //               if (!callback(value)) return { [bodykey]: false };
    //             }
    //           } else {
    //             if (!callback(body[key])) return { [key]: false };
    //           }
    //         }
    //       }
    //     } else {
    //       for (const [bodykey, value] of Object.entries(body)) {
    //         if (!value) return { [bodykey]: false };
    //       }
    //     }
    //     return { "*": true };
    //   }
    // },
    binarySearchIndex(array, find, key = "id") {
      let start = 0;
      let end = array.length - 1;
      let mid = Math.floor((start + end) / 2);
      while (array[mid][key] !== find && start < end) {
        if (find < array[mid][key]) {
          end = mid - 1;
        } else {
          start = mid + 1;
        }
        mid = Math.floor((start + end) / 2);
      }
      return array[mid][key] !== find ? -1 : mid;
    },
    changeCollections(url, body, ref, props = {}) {
      const options = {
        authentication: {
          active: false,
        },
        // message: "Data changed successfully",
        ...props,
      };

      const { authentication } = options;

      return new Promise((resolve, reject) => {
        const authObj = this.authenticateData(body, authentication);
        if (authObj && !authObj[Object.keys(authObj)[0]]) {
          reject(`auth: ${Object.keys(authObj)[0]}`);
        } else {
          ref.dialog = false;
          this.addData(url, body)
            .then(() => {
              this.clearFields();
              this.loadData();
              resolve();
            })
            .catch((err) => reject(err));
        }
      });
    },
    changeDateFormat(dateString, option = "date") {
      const [formatDate] = dateString.split("T");
      const [year, month, day] = formatDate.split("-");
      const date = new Date(dateString);
      const [hour, minute] = [date.getHours(), date.getMinutes()].map((value) =>
        this.getPrefixZeroString(value, "2")
      );

      let formated_str = "";
      if (option == "date") formated_str = `${day}/${month}/${year}`;
      else if (option == "datetime")
        formated_str = `${day}/${month}/${year} ${hour}:${minute}`;

      return formated_str;
    },
    changeStackCollections(collections) {
      const array = [...collections];
      this.quickSort(array, 0, array.length - 1, "id");
      return array.reverse();
    },
    clearOnCancel(ref) {
      ref.dialog = false;
      for (const key in this.validation) {
        this.validation[key] = false;
      }
      this.clearFields();
      this.$store.dispatch("ClearPermission", false);
      this.$store.dispatch("clearNewPermissionData");
      this.$store.dispatch("createNewUserGpTable", null);
      this.$store.dispatch("chkUserGroup", 2);
      this.$store.dispatch("CreatePartData", null);
      this.$store.dispatch("AccessIsVisible", false);
    },
    formatDuration(duration) {
      let time = [
        Math.floor(duration / 60) + "",
        Math.floor(duration % 60) + "",
      ];
      time.forEach((value) => {
        while (value.length < 2) value = "0" + value;
      });
      return `${time[0]}:${time[1]}`;
    },
    getAuthorizationHeader() {
      return {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("vivek_token"),
        },
      };
    },
    getBase64FileData(file) {
      if (file) {
        const fname = file.name.replace(/\s/g, "");
        const fr = new FileReader();

        fr.readAsDataURL(file);
        return new Promise((resolve, reject) => {
          fr.addEventListener("load", () => {
            if (!fr.result) reject(["", "Fail Reading base64 data"]);
            resolve([fname, fr.result]);
          });
        });
      } else return ["", ""];
    },
    getPrefixZeroString(str, length) {
      let prefixStr = str + "";
      while (prefixStr.length < length) {
        prefixStr = "0" + prefixStr;
      }

      return prefixStr;
    },
    async getCropedUrlString(e) {
      try {
        const img = await this.getFileUrlAndName(e);
        const url = img.data;
        return url;
      } catch (err) {
        alert(err);
      }
    },
    // async getUploadUrlString(fileObj) {
    //   if (fileObj.hasOwnProperty("fileObj") && fileObj.fileObj) {
    //     try {
    //       const url = await this.getFileUrlFromServer(fileObj.fileObj);
    //       return url;
    //     } catch (err) {
    //       alert(err);
    //     }
    //   } else {
    //     return "";
    //   }
    // },
    getData(url, option = {}, props = {}) {
      const body = {
        page: 0,
        per_page: 0,
        ...props,
      };
      const options = {
        parse: false,
        httpVerb: "post",
        ...option,
      };
      const { parse, httpVerb } = options;
      const headers = this.getAuthorizationHeader();

      let promise = null;
      if (httpVerb == "get") {
        promise = axios.get(`${this.web_url}${url}`, headers);
      } else if (httpVerb == "post") {
        promise = axios.post(`${this.web_url}${url}`, body, headers);
      }

      if (promise) {
        if (parse) {
          return new Promise((resolve, reject) => {
            promise
              .then((res) => {
                resolve(res.data.data);
              })
              .catch((err) => reject(err));
          });
        } else {
          return promise;
        }
      }
    },
    async getFileUrlAndName(e) {
      try {
        const headers = this.getAuthorizationHeader();
        let data = {
          base64: e.base64,
          fileName: e.fileName,
        };
        const res = axios.post(
          `${this.web_url}File/UploadFileStringBase`,
          data,
          headers
        );
        return res;
      } catch (error) {
        alert(error);
      }
    },
    async getFileUrlFromServer(file) {
      const res = await this.uploadWithFormData({ file });
      return res.data.data;
    },
    getMediaDuration(url, mediaType = "video") {
      return new Promise((resolve, reject) => {
        if (!url) reject("error getting duration");

        const media = document.createElement(mediaType);
        media.src = url;

        media.addEventListener("loadeddata", () => {
          resolve(media.duration);
        });
      });
    },
    isString(value) {
      return typeof value === "string" || value instanceof String;
    },

    async checkpermission(v) {
      const headers = this.getAuthorizationHeader();
      let userID = parseInt(localStorage.getItem("UserID"));
      const res = await axios.get(
        `${this.web_url}EmployeeEXT/CheckPermissionByUserID?userid=` +
          userID +
          `&permissionid=` +
          v,
        headers
      );

      return res.data.data;
    },
    partition(array, start, end, key) {
      let pivot = array[end][key];
      let i = start - 1;

      for (let j = start; j <= end - 1; j++) {
        if (array[j][key] <= pivot) {
          i++;
          [array[i], array[j]] = [array[j], array[i]];
        }
      }
      [array[i + 1], array[end]] = [array[end], array[i + 1]];
      return i + 1;
    },
    quickSort(array, start, end, key) {
      if (start < end) {
        let pi = this.partition(array, start, end, key);
        this.quickSort(array, start, pi - 1, key);
        this.quickSort(array, pi + 1, end, key);
      }
    },
    removeCollectionsById(url) {
      return new Promise((resolve, reject) => {
        this.removeDataById(url, this.id)
          .then(async () => {
            if (this.url) this.loadData();
            resolve();
          })
          .catch((err) => reject(err));
      });
    },
    removeData(url, body) {
      const headers = this.getAuthorizationHeader();
      return axios.post(`${this.web_url}${url}`, body, headers);
    },
    removeDataById(url, id) {
      const headers = this.getAuthorizationHeader();
      return axios.post(`${this.web_url}${url}`, { id }, headers);
    },
    uploadWithFormData(data = { file: this.file }, props = {}) {
      const options = {
        url: `${this.web_url}File/UploadFile`,
        form_data: null,
        option: {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + localStorage.getItem("vivek_token"),
          },
        },
        ...props,
      };

      const { url, option, form_data } = options;

      if (form_data) return axios.post(url, form_data, option);

      const formData = new FormData();
      for (const [key, value] of Object.entries(data)) {
        formData.append(key, value);
      }

      return axios.post(url, formData, option);
    },
  },
  mounted() {
    let comID = localStorage.getItem("companyID");
    if (comID) {
      this.$emit("toggleNavBarCall", "userLogIn");//for nav bar show.
    }
  },
};